import axios from "axios";
import {headers} from "@/services/headers"
import {ThunkAction} from "@reduxjs/toolkit";
import {RootState} from "../store";
import {getErrors, loading, setExportRoute, setGuest, setGuests, setPaginator} from "@/reducers/guests";

export const GetGuests = (eventCode?: string, query?: string, page = 1):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .get(process.env.REACT_APP_BASE_URL + '/org/events/' + eventCode + '/attendees?filter[search]=' + query + '&page=' + page, {
            headers: headers()
        }).then((response) => {
            dispatch(setGuests(response.data.data));
            dispatch(setPaginator(response.data.meta));
            dispatch(setExportRoute(response.data.export_route));

            dispatch(loading(false))
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};

export const RefundTicket = (eventId?: number, buyerId?: number):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .patch(process.env.REACT_APP_BASE_URL + '/org/events/' + eventId + '/attendees/' + buyerId + '/refund', {},{
            headers: headers()
        }).then((response) => {
            dispatch(setGuest(response.data.data));

            dispatch(loading(false))
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};

export const AbsenTicket = (eventId?: number, buyerId?: number):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .patch(process.env.REACT_APP_BASE_URL + '/org/events/' + eventId + '/attendees/' + buyerId + '/absen', {},{
            headers: headers()
        }).then((response) => {
            dispatch(setGuest(response.data.data));

            dispatch(loading(false))
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};
